import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { RestaurantService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { FrontDesk } from '@hmp'

const log = new Logger('FrontDeskResolver')
@Injectable({ providedIn: 'root' })
export class FrontDeskResolver implements Resolve<Observable<FrontDesk>> {
  constructor(
    private resService: RestaurantService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['_id']
    
    return this.resService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/frontdesk-manager']))
    )
  }
}
